import React, { useState, useContext, useEffect } from 'react';
import {IProps} from './types';
import Tooltip from '@components/Tooltip';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import { findCommonAttributeValue } from '@utils/editor'
import {ReactComponent as SuperscriptIcon} from 'assets/svgs/superscript.svg';

const FontSuperscriptCommandOption:React.FC<IProps> = (props) => {      
  let context = useContext(Context);
  const [isSelected, setIsSelected]= useState(false);

  useEffect(() => {
    const fontSuperscript = findCommonAttributeValue(context.editorStatus.selectedElementsId, context.data, "superscript", "Text", context.editorStatus.textSelectionInformation);
    setIsSelected(fontSuperscript===undefined?false:fontSuperscript.toString()==="true");
  }, [context.editorStatus.selectedElementsId.length, context.editorStatus.selectedElementsId[0], context.data, context.editorStatus.textSelectionInformation]);

  const SetFontSuperscript = () => {          
    setIsSelected(!isSelected);        
    context.onCommandChange("superscript", !isSelected);
    //Superscript/subscript mutually exclusive
    if(!isSelected) {
      const notCommand = "subscript";
      const fontSubscript = findCommonAttributeValue(context.editorStatus.selectedElementsId, context.data, notCommand, "Text", context.editorStatus.textSelectionInformation);
      const isSubscript = fontSubscript === undefined ? false : fontSubscript.toString() === "true";
      if (isSubscript) {
        context.onCommandChange(notCommand, isSelected);
      }
    }

  }

  return (
    <S.Root>
         <Tooltip tip={"Superscript"}>
        <S.ButtonContainer onClick={SetFontSuperscript} isSelected={isSelected}>       
            <SuperscriptIcon/>        
        </S.ButtonContainer>
        </Tooltip>
    </S.Root>
  );

}

export default FontSuperscriptCommandOption;